import DOMPurify from 'dompurify';

export const getToolbarWithLinks = () => ({
	toolbar: [
		['bold', 'italic', { script: 'sub' }, { script: 'super' }],
		[{ list: 'ordered' }, { list: 'bullet' }],
		['link']
	]
});

export const SanitizedHTML = (content: string) => {
	let sanitizedContent = DOMPurify.sanitize(content, {
		ALLOWED_ATTR: ['class', 'style', 'target', 'href', 'rel']
	});

	sanitizedContent = sanitizedContent.replace(
		/<a\s+([^>]*?)href\s*=\s*["']([^"']*?)["']([^>]*?)>/gi,
		(match, beforeHref, hrefValue, afterHref) => {
			let fixedHref = hrefValue;
			if (
				!hrefValue.match(/^https?:\/\//i) &&
				!hrefValue.startsWith('#') &&
				!hrefValue.startsWith('/') &&
				!hrefValue.startsWith('mailto:') &&
				!hrefValue.startsWith('tel:') &&
				hrefValue.includes('.')
			) {
				fixedHref = `https://${hrefValue}`;
			}

			const cleanBeforeHref = beforeHref.replace(/\s*target\s*=\s*["'][^"']*["']/gi, '').trim();
			const cleanAfterHref = afterHref.replace(/\s*rel\s*=\s*["'][^"']*["']/gi, '').trim();

			const space1 = cleanBeforeHref ? ' ' : '';
			const space2 = cleanAfterHref ? ' ' : '';
			return `<a${space1}${cleanBeforeHref} href="${fixedHref}"${space2}${cleanAfterHref} target="_blank" rel="noopener noreferrer">`;
		}
	);
	return sanitizedContent;
};

export const ensureLinksOpenInNewWindow = (element: HTMLElement) => {
	const links = element.querySelectorAll('a[href]');
	links.forEach((link: HTMLAnchorElement) => {
		link.setAttribute('target', '_blank');
		link.setAttribute('rel', 'noopener noreferrer');

		const href = link.getAttribute('href');
		if (href) {
			if (
				!href.match(/^https?:\/\//i) &&
				!href.startsWith('#') &&
				!href.startsWith('/') &&
				!href.startsWith('mailto:') &&
				!href.startsWith('tel:')
			) {
				if (href.includes('.')) {
					link.setAttribute('href', `https://${href}`);
				}
			}
		}
	});

	processTextNodesForUrls(element);
};

const processTextNodesForUrls = (element: HTMLElement) => {
	const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null);

	const textNodes: Text[] = [];
	let node = walker.nextNode();
	while (node) {
		textNodes.push(node as Text);
		node = walker.nextNode();
	}

	textNodes.forEach((textNode) => {
		const text = textNode.textContent || '';
		const urlRegex = /(?<![@])(?<!href=["'])\b((?:www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?)\b(?![@])/g;

		if (urlRegex.test(text) && !textNode.parentElement?.closest('a')) {
			urlRegex.lastIndex = 0;

			const newHTML = text.replace(urlRegex, (match, _capturedGroup, offset) => {
				const beforeMatch = text.substring(Math.max(0, offset - 1), offset);
				const afterMatch = text.substring(offset + match.length, offset + match.length + 1);

				if (beforeMatch === '@' || afterMatch === '@') {
					return match;
				}

				const href = match.startsWith('www.') ? `https://${match}` : `https://${match}`;
				return `<a href="${href}" target="_blank" rel="noopener noreferrer">${match}</a>`;
			});

			if (newHTML !== text) {
				const wrapper = document.createElement('span');
				wrapper.innerHTML = newHTML;
				textNode.parentNode?.replaceChild(wrapper, textNode);
			}
		}
	});
};
